import CoursesHeader from './CoursesHeader';
import { CoursesHeaderProps, CoursesHeaderValueProps } from './types';

export type { CoursesHeaderProps, CoursesHeaderValueProps };
export default CoursesHeader;
